export default {
  toggleLoadingMounted (state, value) {
    state.loadingMounted = value
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/mutations.js